import db from './../db';

export default {
    get: function(url) {
        return new Promise(function (resolve, reject) {
            resolve({
                body: db.todos.slice()
            });
        });
    }
};



// WEBPACK FOOTER //
// ./test/data/todo/getAll.js